import { useState } from 'react';
import SectionHeading from '@/components/base/SectionHeading';
import WorkCard from '@/components/base/WorkCard';
import { works } from '@/mocks/movies';

const PAGE_SIZE = 4;

export default function LatestWorks() {
  const sorted = [...works].sort((a, b) => b.year - a.year || b.views - a.views);
  const [count, setCount] = useState(PAGE_SIZE);
  const visible = sorted.slice(0, count);
  const hasMore = count < sorted.length;

  return (
    <section className="mx-auto w-full px-4 py-14 md:px-6 md:py-16">
      <SectionHeading
        eyebrow="NEW ARRIVALS"
        title="新品上线"
        description="最新收录的影视作品，第一时间了解剧情脉络与看点。"
      />

      <div className="grid grid-cols-2 gap-4 md:grid-cols-4 md:gap-5">
        {visible.map((work) => (
          <WorkCard key={work.id} work={work} showSynopsis />
        ))}
      </div>

      <div className="mt-8 flex items-center justify-center gap-4">
        <span className="text-xs text-secondary-500">
          已显示 {visible.length} / {sorted.length} 部
        </span>
        {hasMore ? (
          <button
            type="button"
            onClick={() => setCount((prev) => Math.min(prev + PAGE_SIZE, sorted.length))}
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
          >
            加载更多
            <i className="ri-arrow-down-line" aria-hidden="true" />
          </button>
        ) : (
          <span className="rounded-md bg-background-100 px-4 py-2.5 text-sm text-secondary-500">已加载全部作品</span>
        )}
      </div>
    </section>
  );
}